export default __webpack_public_path__ + "static/media/File_No_4.71cdf8b3.pdf";